import {HandleRemoveTeacher} from './requests/TeacherRequests';
import { navigate } from 'hookrouter';
import { useTranslation } from 'react-i18next';
import { TEACHER_DETAILS_HEADER_TEACHER_IS_ONLY_TEACHER_WARN } from '../../i18n/keyConstants';


export async function RemoveTeacher(teacherId, dispatch, t)
{
    const response = await HandleRemoveTeacher(teacherId);
    if(response.success)
    {
        dispatch({type: 'SHOW_DELETED_TOAST', payload: {teacherId: teacherId}});
        navigate('/exlTeachers');
    }
    else if(response.status === 400)
    {
        dispatch({type: 'SHOW_GENERIC_EXL_ERROR_TOAST', payload: t(TEACHER_DETAILS_HEADER_TEACHER_IS_ONLY_TEACHER_WARN, { ns: 'teacherDetailsHeader' })});
        return null;
    }
}
